// src/pages/chat/PlansModal.jsx
import React from 'react';
import { X, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function PlansModal({ isOpen, onClose, plans = [], onCheckout }) {
    const { t } = useTranslation();
    if (!isOpen) return null;

    const planList = Array.isArray(plans) ? plans : [];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-7xl w-full max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="sticky top-0 bg-white p-6 border-b flex justify-between items-center z-10">
                    <h2 className="text-3xl font-bold text-gray-900">{t('chatbot.plans_modal.choose_plan')}</h2>
                    <button onClick={onClose} className="p-3 hover:bg-gray-100 rounded-full transition">
                        <X className="w-6 h-6" />
                    </button>
                </div>

                <div className="p-8">
                    {planList.length === 0 ? (
                        <div className="text-center py-20">
                            <p className="text-xl text-gray-500">{t('chatbot.plans_modal.loading')}</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {planList.map((plan) => (
                                <div
                                    key={plan.id}
                                    className="border-2 border-gray-200 rounded-2xl p-8 hover:shadow-2xl hover:border-blue-500 transition-all duration-300 text-center"
                                >
                                    <h3 className="text-2xl font-bold text-gray-900">{plan.name}</h3>

                                    <div className="mt-6">
                                        <span className="text-5xl font-extrabold text-gray-900">
                                            ${parseFloat(plan.price).toFixed(2)}
                                        </span>
                                        <span className="text-lg text-gray-500"> {t('chatbot.plans_modal.per_month')}</span>
                                    </div>

                                    <p className="text-sm text-gray-500 mt-2">
                                        {plan.duration_days} {t('chatbot.plans_modal.days_access')}
                                    </p>

                                    <ul className="mt-8 space-y-4 text-left">
                                        {plan.features.map((feature, i) => (
                                            <li key={i} className="flex items-start gap-3 text-sm text-gray-700">
                                                <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                                                <span>{feature}</span>
                                            </li>
                                        ))}
                                    </ul>

                                    <button
                                        onClick={() => onCheckout(plan.id)}
                                        className="mt-10 w-full py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold rounded-xl hover:from-blue-700 hover:to-blue-800 transition shadow-lg"
                                    >
                                        {t('chatbot.plans_modal.select')} {plan.name}
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}